export default __webpack_public_path__ + "static/media/421.f4f2b36c.gif";